import React, { useCallback, useEffect, useState } from 'react';
import { Car, Wrench } from 'lucide-react';
import api from '../lib/api';
import { Panel } from './DashboardWidgets';
import { SoldReviewCard } from '../pages/service/SoldReviewCard';
import { SR_STATUS, PRIO_CLS, DueTag } from '../pages/service/SoldReview';

export const stageOf = (c) => {
  const sr = c.sold_review || {};
  if (c.delivery_status === 'delivered') return { label: 'Entregue', cls: 'text-muted-foreground bg-muted/40' };
  if (c.service_status === 'ready') return { label: 'Ready for Delivery', cls: 'text-emerald-400 bg-emerald-400/10' };
  if (['requested', 'in_progress'].includes(c.service_status)) return { label: 'Delivery Inspection', cls: 'text-blue-400 bg-blue-400/10' };
  if (sr.status && sr.status !== 'done') return SR_STATUS[sr.status];
  return { label: 'Aguardando Service', cls: 'text-muted-foreground bg-muted/40' };
};

export const useMySoldCars = () => {
  const [cards, setCards] = useState(null);
  const load = useCallback(async () => { try { const { data } = await api.get('/service/sold-review/mine'); setCards(data.cards); } catch (e) { setCards((c) => c || []); } }, []);
  useEffect(() => { load(); const iv = setInterval(load, 30000); return () => clearInterval(iv); }, [load]);
  return { cards, load };
};

export const MySoldCars = () => {
  const { cards: raw, load } = useMySoldCars();
  const cards = raw || [];
  const [openId, setOpenId] = useState(null);
  return (
    <Panel title="Meus carros vendidos no Service" icon={Car} testid="dash-my-sold-cars"
      action={<span className="ent-pill">{cards.length}</span>}>
      {raw === null ? <p className="text-[12px] t-label" data-testid="msc-loading">Carregando...</p> : cards.length ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
          {cards.map((c) => {
            const st = stageOf(c); const sr = c.sold_review || {};
            return (
              <button key={c.id} data-testid={`msc-card-${c.id}`} onClick={() => setOpenId(c.id)} className={`text-left rounded-lg border bg-popover p-3 hover:border-primary/50 transition-colors ${c.overdue ? 'border-red-400/40' : 'border-border'}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold text-[13px] truncate">{c.customer_name}</p>
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${st.cls}`}>{st.label}</span>
                </div>
                <p className="text-[12px] text-muted-foreground truncate">{c.vehicle_desc} · #{c.stock}</p>
                <p className="mono text-[10px] t-label truncate">VIN {c.vin || '—'}</p>
                <div className="flex items-center gap-1.5 mt-2 flex-wrap">
                  <DueTag c={c} />
                  {sr.priority && sr.status !== 'done' && <span className={`ent-tag ${PRIO_CLS[sr.priority]}`}>{sr.priority}</span>}
                  {sr.location && sr.status !== 'done' && <span className="ent-tag">{sr.location}</span>}
                </div>
                {c.items_total > 0 && <p className="text-[11px] t-label mt-1.5 flex items-center gap-1"><Wrench className="w-3 h-3" /> {c.items_done}/{c.items_total} serviços · {sr.items.filter((i) => i.status !== 'done').map((i) => i.servico).slice(0, 3).join(', ') || 'tudo concluído'}</p>}
                {sr.eta_date && sr.status !== 'done' && <p className="text-[11px] t-label">Previsão de conclusão: {sr.eta_date.split('-').reverse().join('/')}</p>}
              </button>
            );
          })}
        </div>
      ) : <p className="text-[12px] t-label">Nenhum carro vendido em andamento no Service.</p>}
      <SoldReviewCard dealId={openId} open={!!openId} onClose={() => setOpenId(null)} onChanged={load} />
    </Panel>
  );
};

export const ServiceStatusStrip = ({ dealId }) => {
  const [c, setC] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(async () => { try { const { data } = await api.get(`/service/sold-review/${dealId}`); setC(data.card); } catch (e) {} }, [dealId]);
  useEffect(() => { if (dealId) load(); }, [dealId, load]);
  if (!c) return null;
  const st = stageOf(c); const sr = c.sold_review || {};
  return (
    <>
      <button data-testid="lw-service-strip" onClick={() => setOpen(true)} className="w-full text-left flex items-center gap-3 flex-wrap rounded-lg border border-border bg-muted/30 px-3 py-2 hover:border-primary/50 transition-colors">
        <Wrench className="w-3.5 h-3.5 text-amber-400" />
        <span className="text-[11px] font-black uppercase tracking-wide text-muted-foreground">Status do Service</span>
        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${st.cls}`}>{st.label}</span>
        <DueTag c={c} />
        {c.items_total > 0 && <span className="text-[11px] t-label">{c.items_done}/{c.items_total} serviços</span>}
        {sr.location && sr.status !== 'done' && <span className="text-[11px] t-label">· {sr.location}</span>}
        <span className="ml-auto text-[11px] text-primary font-semibold">Ver detalhes →</span>
      </button>
      <SoldReviewCard dealId={dealId} open={open} onClose={() => setOpen(false)} onChanged={load} />
    </>
  );
};
